import styled from 'styled-components'

export const Container = styled.div`
  & > * + * {
    margin-top: var(--space-400);
  }
`
